import { useEffect } from "react";
import { DemoFormProvider } from "@/components/DemoForm";
import { Nav } from "@/components/Nav";
import { Marquee } from "@/components/Marquee";
import { Footer } from "@/components/Footer";
import { Hero } from "@/sections/Hero";
import { Problem } from "@/sections/Problem";
import { HowItWorks } from "@/sections/HowItWorks";
import { RoleSuites } from "@/sections/RoleSuites";
import { Security } from "@/sections/Security";
import { Comparison } from "@/sections/Comparison";
import { Calculator } from "@/sections/Calculator";
import { Pricing } from "@/sections/Pricing";
import { Story } from "@/sections/Story";
import { DemoSection } from "@/sections/DemoSection";
import { Faq } from "@/sections/Faq";
import { FinalCta } from "@/sections/FinalCta";
import { captureUtm, track } from "@/lib/analytics";

export default function Home() {
  useEffect(() => {
    captureUtm();
    track("page_view");
  }, []);

  return (
    <DemoFormProvider>
      <div className="min-h-screen bg-white font-body text-slate-900">
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Problem />
          <HowItWorks />
          <RoleSuites />
          <Security />
          <Comparison />
          <Calculator />
          <Pricing />
          <Story />
          <DemoSection />
          <Faq />
          <FinalCta />
        </main>
        <Footer />
      </div>
    </DemoFormProvider>
  );
}
